(() => {
  const template = document.getElementById('FilameltReviewVerification');
  if (!template) return;
  const addAfter = (target, modifier = '') => {
    if (!target || target.nextElementSibling?.classList.contains('fm-review-verification')) return;
    const node = template.content.firstElementChild.cloneNode(true);
    if (modifier) node.classList.add(modifier);
    target.after(node);
    target.dataset.fmReviewVerification = 'true';
  };
  const render = () => {
    document.querySelectorAll('.fm-finder__rating').forEach(target => addAfter(target));
    const widgetSelector = '.jdgm-carousel-wrapper, .jdgm-review-widget, .jdgm-rev-widg, .jdgm-all-reviews-widget';
    document.querySelectorAll(widgetSelector).forEach(target => {
      if (!target.parentElement?.closest(widgetSelector)) addAfter(target);
    });
    document.querySelectorAll('.product__info-container .jdgm-preview-badge, .product__info-container .rating-wrapper').forEach(target => addAfter(target));
    const grids = new Set();
    document.querySelectorAll('.card-wrapper .jdgm-preview-badge, .card-wrapper .rating-wrapper').forEach(badge => {
      const grid = badge.closest('.product-grid, ul.grid');
      if (grid) grids.add(grid);
    });
    document.querySelectorAll('.spf-product-card .jdgm-preview-badge, .spf-product-card .rating-wrapper').forEach(badge => {
      const grid = badge.closest('.product-grid, ul.grid');
      if (grid) grids.add(grid);
    });
    grids.forEach(grid => {
      if (grid.nextElementSibling?.classList.contains('fm-review-verification--grid')) grid.nextElementSibling.remove();
      if (grid.previousElementSibling?.classList.contains('fm-review-verification--grid')) return;
      const node = template.content.firstElementChild.cloneNode(true);
      node.classList.add('fm-review-verification--grid');
      grid.before(node);
    });
  };
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; render(); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render, { once: true }); else render();
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
